import { render, staticRenderFns } from "./TitleDeedAlternativesSection.vue?vue&type=template&id=4c75909c&"
import script from "./TitleDeedAlternativesSection.vue?vue&type=script&lang=js&"
export * from "./TitleDeedAlternativesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports